import React, {useEffect, useState} from 'react'
import {NavLink} from 'react-router-dom'
import styled from 'styled-components'
import useFarms from '../../../hooks/useFarms'
import AccountButton from "./AccountButton";
import logo from '../../../assets/img/bloktopia-logo.png'

const Nav: React.FC = () => {
  const [farms] = useFarms()
  const [poolId, setPoolId] = useState('');

  useEffect(() => {
    if (farms && farms[0]) {
      setPoolId(farms[0].id)
    }
  }, [farms])

  return (
    <StyledNav>
      <StyledTopBarInner>
        <NavLink to={'/'}>
          <StyledLogo
            src={logo}
            alt={'logo'}
          />
        </NavLink>
        <div>
          <StyledLink exact activeClassName="active" to="/">
            Home
          </StyledLink>
          <StyledLink exact activeClassName="active" to={`/pools/${poolId}`}>
            Staking
          </StyledLink>
          <StyledAccountButtonWrapper>
            <AccountButton />
          </StyledAccountButtonWrapper>
        </div>
      </StyledTopBarInner>
    </StyledNav>
  );
}

const StyledNav = styled.nav`
  align-items: center;
  justify-content: space-between;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 auto;
`

const StyledLink = styled(NavLink)`
  color: white;
  font-weight: 700;
  font-size: 14px;
  padding-left: ${(props) => props.theme.spacing[3]}px;
  padding-right: ${(props) => props.theme.spacing[3]}px;
  text-decoration: none;
  &:hover {
    color: ${(props) => props.theme.color.purple[400]};
  }
  @media (max-width: 400px) {
    padding-left: ${(props) => props.theme.spacing[2]}px;
    padding-right: ${(props) => props.theme.spacing[2]}px;
  }
`

const StyledTopBarInner = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  height: ${(props) => props.theme.topBarSize}px;
  justify-content: space-between;
  width: 100%;
  padding: 0 24px;
`

const StyledAccountButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  width: 156px;
  @media (max-width: 400px) {
    justify-content: center;
    width: auto;
  }
`

const StyledLogo = styled.img`
  width: 180px;
  margin-left: 13px;
`;

export default Nav
